'use client';

import {
  AspectRatioKeeper,
  factory,
  Flex,
  Image,
  Link,
  omitText,
  Typography,
  useWindowSize,
} from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import classes from './index.module.scss';
import { getSmartCropWidth } from './index.utils';

export const OverlayMenuImage = factory((props, ref) => {
  const {
    className,
    CTA,
    imagesLength = 1,
    caption,
    image,
    multiCTA,
    imageOrientation = 'landscape',
    href,
    isBusinessTab = true,
    ...rest
  } = props;

  const isSmartCrop = image?.['data-mode'] === 'smartcrop';
  const { width: screenWidth } = useWindowSize();
  const resolvedWidth = getSmartCropWidth({
    screenWidth,
    imagesLength,
    isSmartCrop,
    imageOrientation,
    isBusinessTab,
  });

  return (
    <Flex
      direction="column"
      gap={40}
      ref={ref}
      className={clsx(className, 'kohler-overlay-menu-image-wrapper', classes.overlayMenuImageWrapper)}
      width={resolvedWidth}
      {...rest}
    >
      {multiCTA && multiCTA.length > 0 && (
        <Flex component="ul" direction="column" gap={20}>
          {multiCTA?.map((item) => (
            <Flex key={item.text} component="li" className={classes.overlayMenuCategoryLinksLink}>
              <Link
                {...omitText(item)}
                underline={false}
                rightIcon={<ArrowRightBoldIcon withBoundingBox={false} size="xSmall" />}
                className={classes.overlayMenuCategoryLinksLink}
                size="small"
                textColor="var(--content-primary)"
              >
                {item.text}
              </Link>
            </Flex>
          ))}
        </Flex>
      )}
      <Flex className={clsx('kohler-overlay-menu-image', classes.overlayMenuImage, !isSmartCrop && classes.overlayMenuImageWidth)}>
        <AspectRatioKeeper
          component="a"
          href={CTA?.href ?? href ?? undefined}
          // aspectRatio={isSmartCrop ? 'none' : '4:3'}
          aspectRatio="4:3"
          // aspectRatio={isSmartCrop ? 'none' : imageOrientation === 'landscape' ? '5:4' : '3:4'}
          target={CTA?.target}
          rel={CTA?.target === '_blank' ? 'noopener noreferrer' : undefined}
        >
          <Image {...image} />
        </AspectRatioKeeper>
        {(caption || CTA) && (
          <Flex direction="column" gap={5}>
            {caption && (
              <Typography
                size="label-regular-s"
                textColor="var(--content-secondary)"
                component={isValidElement(caption.text) ? 'div' : caption.component || 'p'}
                {...omitText(caption)}
              >
                {caption.text}
              </Typography>
            )}
            {CTA && CTA.text && (
              <Link
                underline={false}
                rightIcon={<ArrowRightBoldIcon withBoundingBox={false} size="xSmall" />}
                className={classes.overlayMenuImageCTA}
                size="small"
                textColor="var(--Primary-Charcoal)"
                {...omitText(CTA)}
                target={CTA.target}
                rel={CTA.target === '_blank' ? 'noopener noreferrer' : undefined}
              >
                {CTA.text}
            </Link>
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
});